/*====================================
    補收款 相關功能Factory

    Author : Gray
    最後更新時間 : 2017 / 03 / 16
====================================*/

window.InifECShared.factory("ExtraFeeService", ['$q', '$http', 'Upload', function($q, $http, Upload) {

    var factory = this;

    // --------------------------------
    // 取得補收款資訊
    // --------------------------------
    var getExtraFee = function(extrafeeid) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ExtraFeeAction.do",
            method: "GET",
            params: {
                op: "getExtraFee",
                extrafeeid: extrafeeid,
            }
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : ExtraFeeService.getExtraFee request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 設定付款方式
    // --------------------------------
    var setPayType = function(extrafeeid, paymentmethod) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ExtraFeeAction.do",
            method: "POST",
            data: $.param({
                op: "setPayType",
                extrafeeid: extrafeeid,
                paymentmethod: paymentmethod,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : ExtraFeeService.setPayType request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 付補收款（信用卡／虛擬ＡＴＭ／點數）
    // --------------------------------
    var payExtraFee = function(extrafeeid, paymentmethod, totalamount) {

        var defer = $q.defer();
        var keynum = Math.floor((Math.random() * 3) + 1);

        $http({
            url: SECURE_INIFEC_URL + "/ExtraFeeAction.do",
            method: "POST",
            data: $.param({
                op: "payExtraFee",
                extrafeeid: extrafeeid,
                paymentmethod: paymentmethod,
                keynum: keynum,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {

                if (paymentmethod == Paytype_SinopacCreditCard) {
                    _payWithPaytype_SinopacCreditCard(extrafeeid, paymentmethod, totalamount, data, keynum, defer);
                } else {
                    defer.resolve(data);
                }
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : ExtraFeeService.payExtraFee request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // ------------------------------
    // [private] 信用卡付款（踢至銀行付款頁）
    // ------------------------------
    var _payWithPaytype_SinopacCreditCard = function(extrafeeid, paymentmethod, totalamount, data, keynum, defer) {

        // app 付款
        if(window.location.protocol == "file:") {
            var form = {
                method: "POST",
                action: PAYMENT_URL,
                ShopNO: SINOPAC_ShopNO,
                KeyNum: keynum,
                OrderNO: extrafeeid+'-'+paymentmethod+'-'+0,
                Amount: totalamount * 100,
                CurrencyID: "NTD",
                PrdtName: "inif印衣服",
                AutoBilling: "Y",
                Digest: data.gatewayRstJSON,
                Param1: "payFromApp", // 此flag讓永豐回傳可以踢到app要的回傳頁面
            }

            var msg = {
                type: 'payByCreditCard',
                form: form
            }

            msg = JSON.stringify(msg);

            // post msg to app
            if( window.WebViewBridge !== undefined && window.WebViewBridge.postMessage){
                window.WebViewBridge.postMessage(msg);
            } else if( window.WebViewBridge !== undefined && window.WebViewBridge.send){
                window.WebViewBridge.send(msg);
            }
        } else {
            var form = document.createElement("form");

            form.method = "POST";
            form.action = PAYMENT_URL;  

            var ShopNO = document.createElement("input"); 
            //ShopNO改取 SinopacContext.ShopNO 的值
            ShopNO.value= SINOPAC_ShopNO;
            ShopNO.name= "ShopNO";
            form.appendChild(ShopNO);  
            var KeyNum = document.createElement("input"); 
            //keyNum 直改random (1-3),與此次金鑰使用KeyNum 相同
            KeyNum.value= keynum;
            KeyNum.name= "KeyNum";
            form.appendChild(KeyNum);
            var OrderNO = document.createElement("input"); 
            OrderNO.value= extrafeeid+'-'+paymentmethod+'-'+0;
            OrderNO.name= "OrderNO";
            form.appendChild(OrderNO);
            var Amount = document.createElement("input"); 
            // 金額要 *100 傳出
            Amount.value= totalamount * 100;
            Amount.name= "Amount";
            form.appendChild(Amount);
            var CurrencyID = document.createElement("input"); 
            CurrencyID.value= "NTD";
            CurrencyID.name= "CurrencyID";
            form.appendChild(CurrencyID);
            var PrdtName = document.createElement("input"); 
            PrdtName.value= "inif印衣服";
            PrdtName.name= "PrdtName";
            form.appendChild(PrdtName);
            var AutoBilling = document.createElement("input"); 
            AutoBilling.value= "Y";
            AutoBilling.name= "AutoBilling";
            form.appendChild(AutoBilling);
            var Digest = document.createElement("input"); 
            Digest.value= data.gatewayRstJSON;
            Digest.name= "Digest";
            form.appendChild(Digest);

            document.body.appendChild(form);
            form.submit();
        }

        defer.resolve(data);
    }

    // --------------------------------
    // 付補收款（臨櫃匯款）
    // --------------------------------
    var payExtraFeeWithOutwardRemittance = function(extrafeeid, remittanceName, remittanceCode, remittancePhone, remittanceDate) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ExtraFeeAction.do",
            method: "POST",
            data: $.param({
                op: "payExtraFeeWithOutwardRemittance",
                extrafeeid: extrafeeid,
                remittanceName: remittanceName,
                remittanceCode: remittanceCode,
                remittancePhone: remittancePhone,
                remittanceDate: remittanceDate,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : ExtraFeeService.payExtraFeeWithOutwardRemittance request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    // --------------------------------
    // 申請補收款的退款
    // --------------------------------
    var refundExtraFee = function(extrafeeid, refundIssue) {

        var defer = $q.defer();

        $http({
            url: SECURE_INIFEC_URL + "/ExtraFeeAction.do",
            method: "POST",
            data: $.param({
                op: "refundExtraFee",
                extrafeeid: extrafeeid,
                refundIssue: refundIssue,
            }),
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).success(function(data) {
            if (data.error) {
                defer.reject(data.error);
            } else {
                defer.resolve(data);
            }
        }).error(function(data, status, headers, config) {
            defer.reject(data);
            console.error("[InifEC Error] : ExtraFeeService.refundExtraFee request error.");
            console.error("status : " + status);
        });

        return defer.promise;
    }

    factory.getExtraFee = getExtraFee; // 取得補收款資訊
    factory.setPayType = setPayType // 設定付款方式
    factory.payExtraFee = payExtraFee // 付補收款（信用卡／虛擬ＡＴＭ／點數）
    factory.payExtraFeeWithOutwardRemittance = payExtraFeeWithOutwardRemittance // 付補收款（臨櫃匯款）
    factory.refundExtraFee = refundExtraFee; // 申請補收款的退款

    return factory;
}]);
